export default __webpack_public_path__ + "static/media/createAccount.1eaa7ecb.svg";